export default "__VITE_ASSET__BSxuO0hl__"